import React, { useState } from "react";
import config from "lib/fr-config";
import TXT from "presentational/common/multinational/TXT";
import TextButtonView from "presentational/common/TextButtonView";
import CommonModalView from "presentational/common/modals/CommonModalView";
import CommonIconView from "presentational/common/CommonIconView";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { getDeviceType } from "lib/deviceInfo";
import PropTypes from "prop-types";

const fontCss = config.css.fontThickness;
const colorCss = config.css.color;
const MORE_BTN_TYPE = config.iconDesign.moreButton;

const FONT_SIZE_OF_MODAL_CONTENT = 14;

const FONT_SIZE_OF_MORE_TEXT_BTN = 14;
const FONT_COLOR_OF_MORE_TEXT_BTN = colorCss.colorOfPrimary;

const MODAL_TABLE_CELL_PADDING_PX = 6;
const MODAL_PADDING_BETWEEN_TEXT_PX = 7;

const NUM_OF_UNLIMIT_POLL = 5;
const NUM_OF_FREE_MEMBERSHIP = 10;

const cssXL = {
  root: { marginBottom: 100 },
  infoText: {
    display: "flex",
    justifyContent: "center",
    marginBottom: 70
  },
  infoGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    marginBottom: 70
  },
  infoUnit: {
    width: "25%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  modalSectionWrapper: { paddingBottom: 30 },
  modalSectionTitleWrapper: {
    paddingBottom: MODAL_PADDING_BETWEEN_TEXT_PX
  },
  modalSectionTitleWrapperForTable: {
    paddingBottom: MODAL_PADDING_BETWEEN_TEXT_PX - MODAL_TABLE_CELL_PADDING_PX
  },
  modalContentNumListWrapper: {
    listStyleType: "decimal",
    paddingInlineStart: 20,
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  },
  modalContentListUnit: { paddingBottom: MODAL_PADDING_BETWEEN_TEXT_PX },
  modalContentDotListWrapper: {
    listStyleType: "disc",
    paddingInlineStart: 20,
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  },
  moreBtnIcon: { display: "inline-flex" },
  copyLinkBtnText: {
    paddingLeft: 5,
    fontWeight: fontCss.bold
  },
  moreBtnWrapper: { paddingTop: 4 },
  membershipRewardWrapper: { fontWeight: fontCss.bold }
};
const cssXS = {
  root: {},
  infoText: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 70
  },
  infoGroup: {
    display: "flex",
    flexDirection: "column"
  },
  infoUnit: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 70
  },
  modalSectionWrapper: { paddingBottom: 30 },
  modalSectionTitleWrapper: {
    paddingBottom: MODAL_PADDING_BETWEEN_TEXT_PX
  },
  modalSectionTitleWrapperForTable: {
    paddingBottom: MODAL_PADDING_BETWEEN_TEXT_PX - MODAL_TABLE_CELL_PADDING_PX
  },
  modalContentNumListWrapper: {
    listStyleType: "decimal",
    paddingInlineStart: 20,
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  },
  modalContentListUnit: { paddingBottom: MODAL_PADDING_BETWEEN_TEXT_PX },
  modalContentDotListWrapper: {
    listStyleType: "disc",
    paddingInlineStart: 20,
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  },
  moreBtnIcon: { display: "inline-flex" },
  copyLinkBtnText: {
    paddingLeft: 5,
    fontWeight: fontCss.bold
  },
  moreBtnWrapper: { paddingTop: 4 },
  membershipRewardWrapper: { fontWeight: fontCss.bold }
};

const MembershipDescTitleTypo = withStyles({
  root: {
    fontSize: 20,
    paddingBottom: 8,
    fontWeight: fontCss.bold,
    textAlign: "center"
  }
})(Typography);
const MembershipDescXLContentTypo = withStyles({
  root: {
    fontSize: 20,
    fontWeight: fontCss.bold,
    textAlign: "center"
  }
})(Typography);
const MembershipDescContentTypo = withStyles({
  root: {
    fontSize: 16,
    textAlign: "center"
  }
})(Typography);
const ModalSectionTitleTypo = withStyles({
  root: {
    fontSize: FONT_SIZE_OF_MODAL_CONTENT,
    fontWeight: fontCss.bold
  }
})(Typography);
const ModalContentTypo = withStyles({
  root: {
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  }
})(Typography);
const BasicTableCell = withStyles({
  root: {
    padding: MODAL_TABLE_CELL_PADDING_PX,
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  }
})(TableCell);
const HighlightedTableCell = withStyles({
  root: {
    padding: MODAL_TABLE_CELL_PADDING_PX,
    fontWeight: fontCss.bold,
    fontSize: FONT_SIZE_OF_MODAL_CONTENT
  }
})(TableCell);

CouponInfoSectionView.propTypes = {
  membershipInfo: PropTypes.shape({
    userType: PropTypes.string.isRequired,
    canUseFreeTrial: PropTypes.bool,
    paymentType: PropTypes.oneOf(["freeTrial", "paypal", "portone"]),
    status: PropTypes.oneOf(["activated", "deactivated", "paused"]),
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    nextBillingTime: PropTypes.string,
    endTimeOnCancel: PropTypes.string,
    availableDateOfSubscription: PropTypes.string,

    numOfAllCoupon: PropTypes.number.isRequired,
    numOfPromotionCoupon: PropTypes.number.isRequired,
    numOfReferralCoupon: PropTypes.number.isRequired,
    numOfCouponUnused: PropTypes.number.isRequired,
    numOfCouponUsed: PropTypes.number.isRequired,
    invitedUserCount: PropTypes.number.isRequired
  })
};

function CouponInfoSectionView(props) {
  const { membershipInfo } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);

  const css = getDeviceType() === "desktop" ? cssXL : cssXS;

  const invitedUserCount = membershipInfo.invitedUserCount || 0;
  const numOfReferralCoupon = membershipInfo.numOfReferralCoupon || 0;
  const numOfPromotionCoupon = membershipInfo.numOfPromotionCoupon || 0;
  const numOfCouponUsed = membershipInfo.numOfCouponUsed || 0;
  const numOfCouponUnused = membershipInfo.numOfCouponUnused || 0;

  const getPercentOfReward = ({ motherNum, sonNum }) => {
    if (motherNum === 0) return 0;
    let percent = (sonNum / motherNum) * 100;
    percent = Math.round(percent);
    return percent > 100 ? 100 : percent;
  };

  const getRewardProgressText = type => {
    const sonNum = numOfReferralCoupon;
    let motherNum = 0;
    switch (type) {
      case "unlimitPoll":
        motherNum = NUM_OF_UNLIMIT_POLL;
        break;
      case "freeMembership":
        motherNum = NUM_OF_FREE_MEMBERSHIP;
        break;
      default:
        console.error(`wrong type:"${type}"`);
        break;
    }

    const progressNumStr = `${sonNum}/${motherNum}`;
    const percentStr = `${getPercentOfReward({ motherNum, sonNum })}%`;
    return `${progressNumStr}, ${percentStr}`;
  };

  const getModalInfo = type => {
    switch (type) {
      case "howToGetIt":
        return {
          title: <TXT name="titleMembSection_howToGetCouponDesc" />,
          content: (
            <div>
              <ol style={css.modalContentNumListWrapper}>
                <li style={css.modalContentListUnit}>
                  <ModalContentTypo>
                    <TXT name="msg_howToGetCouponModalContent1" />
                  </ModalContentTypo>
                </li>
                <ol style={css.modalContentDotListWrapper}>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_howToGetCouponModalContent2"
                        input={{
                          moreBtn: (
                            <span style={css.moreBtnIcon}>
                              <CommonIconView type={MORE_BTN_TYPE} />
                            </span>
                          ),
                          copyLinkBtn: (
                            <span style={css.copyLinkBtnText}>
                              <TXT name="btnList_copyLink" />
                            </span>
                          )
                        }}
                      />
                    </ModalContentTypo>
                  </li>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_howToGetCouponModalContent3"
                        input={{
                          moreBtn: (
                            <span style={css.moreBtnIcon}>
                              <CommonIconView type={MORE_BTN_TYPE} />
                            </span>
                          ),
                          copyLinkBtn: (
                            <span style={css.copyLinkBtnText}>
                              <TXT name="btnList_copyLink" />
                            </span>
                          )
                        }}
                      />
                    </ModalContentTypo>
                  </li>
                </ol>
                <li style={css.modalContentListUnit}>
                  <ModalContentTypo>
                    <TXT name="msg_howToGetCouponModalContent4" />
                  </ModalContentTypo>
                </li>
                <ol style={css.modalContentDotListWrapper}>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT name="msg_howToGetCouponModalContent5" />
                    </ModalContentTypo>
                  </li>
                </ol>
                <li style={css.modalContentListUnit}>
                  <ModalContentTypo>
                    <TXT name="msg_howToGetCouponModalContent6" />
                  </ModalContentTypo>
                </li>
              </ol>
            </div>
          )
        };

      case "howToUse":
        return {
          title: <TXT name="titleMembSection_howToUseCouponDesc" />,
          content: (
            <div>
              <ol style={css.modalContentDotListWrapper}>
                <li style={css.modalContentListUnit}>
                  <ModalContentTypo>
                    <TXT name="msg_howToUseCouponModalContent1" />
                  </ModalContentTypo>
                </li>
                <li style={css.modalContentListUnit}>
                  <ModalContentTypo>
                    <TXT name="msg_howToUseCouponModalContent2" />
                  </ModalContentTypo>
                </li>
                <li style={css.modalContentListUnit}>
                  <ModalContentTypo>
                    <TXT name="msg_howToUseCouponModalContent3" />
                  </ModalContentTypo>
                </li>
              </ol>
            </div>
          )
        };

      case "couponCount":
        return {
          title: <TXT name="msg_myCouponInfo" />,
          content: (
            <div>
              <div style={css.modalSectionWrapper}>
                <div style={css.modalSectionTitleWrapper}>
                  <ModalSectionTitleTypo>
                    <TXT name="msg_referralSummary" />
                  </ModalSectionTitleTypo>
                </div>
                <ol style={css.modalContentDotListWrapper}>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_friendsInvited"
                        input={{ numUsed: invitedUserCount }}
                      />
                    </ModalContentTypo>
                  </li>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_friendsWhoStartedMC"
                        input={{ numUsed: numOfReferralCoupon }}
                      />
                    </ModalContentTypo>
                  </li>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_couponsEarned"
                        input={{ numUsed: numOfReferralCoupon }}
                      />
                    </ModalContentTypo>
                  </li>
                </ol>
              </div>
              <div style={css.modalSectionWrapper}>
                <div style={css.modalSectionTitleWrapperForTable}>
                  <ModalSectionTitleTypo>
                    <TXT name="msg_couponBalance" />
                  </ModalSectionTitleTypo>
                </div>
                <Table>
                  <TableHead>
                    <TableRow>
                      <BasicTableCell></BasicTableCell>
                      <BasicTableCell align="right">
                        <TXT name="msg_couponCount" />
                      </BasicTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <BasicTableCell>
                        <TXT name="msg_coupons" />
                      </BasicTableCell>
                      <BasicTableCell align="right">
                        {numOfReferralCoupon}
                      </BasicTableCell>
                    </TableRow>
                    <TableRow>
                      <BasicTableCell>
                        <TXT name="msg_promotionalCoupons" />
                      </BasicTableCell>
                      <BasicTableCell align="right">{`+${numOfPromotionCoupon}`}</BasicTableCell>
                    </TableRow>
                    <TableRow>
                      <BasicTableCell>
                        <TXT name="msg_couponsUsed" />
                      </BasicTableCell>
                      <BasicTableCell align="right">{`-${numOfCouponUsed}`}</BasicTableCell>
                    </TableRow>
                    <TableRow>
                      <HighlightedTableCell>
                        <TXT name="msg_availableCoupons" />
                      </HighlightedTableCell>
                      <HighlightedTableCell align="right">
                        {numOfCouponUnused}
                      </HighlightedTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>
          )
        };

      case "couponBonus":
        return {
          title: <TXT name="msg_couponBenefitsOverview" />,
          content: (
            <div>
              <div style={css.modalSectionWrapper}>
                <div style={css.modalSectionTitleWrapper}>
                  <ModalSectionTitleTypo>
                    <TXT name="msg_couponRewards" />
                  </ModalSectionTitleTypo>
                </div>
                <ol style={css.modalContentDotListWrapper}>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT name="msg_couponRewardsDesc1" />
                    </ModalContentTypo>
                  </li>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT name="msg_couponRewardsDesc2" />
                    </ModalContentTypo>
                    <ModalContentTypo>
                      <TXT name="msg_couponRewardsDesc3" />
                    </ModalContentTypo>
                  </li>
                </ol>
              </div>
              <div style={css.modalSectionWrapper}>
                <div style={css.modalSectionTitleWrapper}>
                  <ModalSectionTitleTypo>
                    <TXT name="msg_couponProgress" />
                  </ModalSectionTitleTypo>
                </div>
                <ol style={css.modalContentDotListWrapper}>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_msg_couponProgressUnlimitedVoting"
                        input={{
                          progressStr: getRewardProgressText("unlimitPoll")
                        }}
                      />
                    </ModalContentTypo>
                  </li>
                  <li style={css.modalContentListUnit}>
                    <ModalContentTypo>
                      <TXT
                        name="msg_msg_couponProgressMembershipFree"
                        input={{
                          progressStr: getRewardProgressText("freeMembership")
                        }}
                      />
                    </ModalContentTypo>
                  </li>
                </ol>
              </div>
            </div>
          )
        };

      default:
        console.error(`wrong type : ${type}`);
        break;
    }
  };

  const handleMoreDetailBtnClick = type => () => {
    const { title, content } = getModalInfo(type);
    setModalTitle(title);
    setModalContent(content);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <div style={css.root}>
      <div style={css.infoText}>
        <MembershipDescTitleTypo>
          <TXT name="msg_couponDescMsg1" />
        </MembershipDescTitleTypo>
      </div>
      <div style={css.infoGroup}>
        <div style={css.infoUnit}>
          <MembershipDescXLContentTypo>
            <TXT
              name="msg_friendsInvited"
              input={{ numUsed: invitedUserCount }}
            />
          </MembershipDescXLContentTypo>
          <MembershipDescXLContentTypo>
            <TXT
              name="msg_couponsEarned"
              input={{ numUsed: numOfReferralCoupon }}
            />
          </MembershipDescXLContentTypo>
          <span style={css.moreBtnWrapper}>
            <TextButtonView
              fontSize={FONT_SIZE_OF_MORE_TEXT_BTN}
              fontColor={FONT_COLOR_OF_MORE_TEXT_BTN}
              onClick={handleMoreDetailBtnClick("couponCount")}
            >
              <TXT name="btnViewMore_moreCouponInfo" />
            </TextButtonView>
          </span>
        </div>
        <div style={css.infoUnit}>
          <MembershipDescTitleTypo>
            <TXT name="msg_couponBenefitsOverview" />
          </MembershipDescTitleTypo>
          <MembershipDescContentTypo>
            <TXT name="msg_couponBenefitsOverviewDesc1" />
          </MembershipDescContentTypo>
          <MembershipDescContentTypo>
            <TXT name="msg_couponBenefitsOverviewDesc2" />
            <span style={css.membershipRewardWrapper}>
              <TXT name="msg_couponBenefitsOverviewDesc2_2" />
            </span>
          </MembershipDescContentTypo>
          <MembershipDescContentTypo>
            <TXT name="msg_couponBenefitsOverviewDesc3" />
            <span style={css.membershipRewardWrapper}>
              <TXT name="msg_couponBenefitsOverviewDesc3_2" />
            </span>
          </MembershipDescContentTypo>
          <span style={css.moreBtnWrapper}>
            <TextButtonView
              fontSize={FONT_SIZE_OF_MORE_TEXT_BTN}
              fontColor={FONT_COLOR_OF_MORE_TEXT_BTN}
              onClick={handleMoreDetailBtnClick("couponBonus")}
            >
              <TXT name="btnViewMore_moreCouponInfo" />
            </TextButtonView>
          </span>
        </div>
      </div>
      <div style={css.infoGroup}>
        <div style={css.infoUnit}>
          <MembershipDescTitleTypo>
            <TXT name="titleMembSection_howToGetCouponDesc" />
          </MembershipDescTitleTypo>
          <MembershipDescContentTypo>
            <TXT name="msg_howToGetCouponDesc" />
          </MembershipDescContentTypo>
          <span style={css.moreBtnWrapper}>
            <TextButtonView
              fontSize={FONT_SIZE_OF_MORE_TEXT_BTN}
              fontColor={FONT_COLOR_OF_MORE_TEXT_BTN}
              onClick={handleMoreDetailBtnClick("howToGetIt")}
            >
              <TXT name="btnViewMore_moreCouponInfo" />
            </TextButtonView>
          </span>
        </div>
        <div style={css.infoUnit}>
          <MembershipDescTitleTypo>
            <TXT name="titleMembSection_howToUseCouponDesc" />
          </MembershipDescTitleTypo>
          <MembershipDescContentTypo>
            <TXT name="msg_howToUseCouponDesc" />
          </MembershipDescContentTypo>
          <span style={css.moreBtnWrapper}>
            <TextButtonView
              fontSize={FONT_SIZE_OF_MORE_TEXT_BTN}
              fontColor={FONT_COLOR_OF_MORE_TEXT_BTN}
              onClick={handleMoreDetailBtnClick("howToUse")}
            >
              <TXT name="btnViewMore_moreCouponInfo" />
            </TextButtonView>
          </span>
        </div>
      </div>
      <div>
        <CommonModalView
          open={modalOpen}
          onClose={handleModalClose}
          titleText={modalTitle}
          contentComponent={modalContent}
          firstButtonText={<TXT name="btnModal_close" />}
          firstButtonFunc={handleModalClose}
        />
      </div>
    </div>
  );
}

export default CouponInfoSectionView;
